// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2ces_","colCheckbox":"styles_colCheckbox__1WHjp"};